"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

require("../styles/_footer.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function disablePrimaryButton(fn, setPrimaryButtonDisabled) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _ref2, error;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fn();

          case 2:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 5;
              break;
            }

            _context.t0 = {};

          case 5:
            _ref2 = _context.t0;
            error = _ref2.error;

            if (!error) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return");

          case 9:
            setPrimaryButtonDisabled(true);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

function onApproveAndRequestReview(_ref3) {
  var onRequestApproval = _ref3.onRequestApproval,
      onApproveVersion = _ref3.onApproveVersion;
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return onApproveVersion();

          case 2:
            _context2.next = 4;
            return onRequestApproval();

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

var hasApprovePermissions = function hasApprovePermissions(status, videoPermissions) {
  return status.isCustom ? videoPermissions.includes(status.requiredPermission) : (0, _commonReact.hasPermission)('APPROVE', videoPermissions);
};

var deriveChildProps = function deriveChildProps(props, primaryButtonDisabled, setPrimaryButtonDisabled) {
  var _props$status = props.status,
      status = _props$status === void 0 ? {} : _props$status,
      comments = props.comments,
      versionNumber = props.versionNumber,
      onApproveVersion = props.onApproveVersion,
      onRequestChanges = props.onRequestChanges,
      onRequestApproval = props.onRequestApproval,
      videoPermissions = props.videoPermissions,
      hasUpdatePermission = props.hasUpdatePermission,
      internalMode = props.internalMode,
      isVideoReady = props.isVideoReady,
      isLatestVersion = props.isLatestVersion,
      _props$currentVersion = props.currentVersion,
      appliedAddons = _props$currentVersion.appliedAddons,
      requestedAddons = _props$currentVersion.requestedAddons,
      nextStatus = props.nextStatus,
      goBackToProjects = props.goBackToProjects;
  var statusName = status.name;
  var addonsChanged = !(0, _lodash.default)(appliedAddons, requestedAddons);
  var secondaryButtonDisabled = !comments.size && !addonsChanged || versionNumber === 5;

  if (!hasUpdatePermission || !isVideoReady || statusName === 'APPROVED' || statusName === 'EDITING' || !isLatestVersion || statusName === 'INTERNAL_REVIEW' && !internalMode) {
    return {
      onClickPrimary: goBackToProjects,
      primaryButtonText: 'Back To Projects',
      onClickSecondary: null
    };
  }

  if (statusName === 'COST_REVIEW') {
    return _objectSpread({}, (0, _commonReact.hasPermission)('COST_APPROVAL', videoPermissions) ? {
      onClickPrimary: onApproveVersion,
      onClickSecondary: onRequestChanges,
      primaryButtonText: 'Approve Version',
      secondaryButtonDisabled: secondaryButtonDisabled
    } : {
      onClickPrimary: disablePrimaryButton(onRequestApproval, setPrimaryButtonDisabled),
      onClickSecondary: onRequestChanges,
      primaryButtonText: primaryButtonDisabled ? 'Approval Requested' : 'Request Approval',
      secondaryButtonDisabled: true
    }, {
      secondaryButtonText: 'Submit Changes',
      primaryButtonDisabled: primaryButtonDisabled
    });
  }

  if (internalMode && statusName === 'INTERNAL_REVIEW' && (0, _commonReact.hasPermission)('APPROVE_INTERNAL', videoPermissions)) {
    return {
      onClickPrimary: onApproveVersion,
      onClickSecondary: onRequestChanges,
      primaryButtonText: 'Approve Version',
      secondaryButtonText: 'Reject Version',
      primaryButtonDisabled: primaryButtonDisabled
    };
  }

  if (!hasApprovePermissions(status, videoPermissions)) {
    return {
      onClickPrimary: disablePrimaryButton(onRequestApproval, setPrimaryButtonDisabled),
      onClickSecondary: onRequestChanges,
      primaryButtonText: primaryButtonDisabled ? 'Approval Requested' : 'Request Approval',
      secondaryButtonText: 'Submit Changes',
      secondaryButtonDisabled: status.isCustom,
      primaryButtonDisabled: primaryButtonDisabled
    };
  }

  if (hasApprovePermissions(status, videoPermissions) && nextStatus !== 'APPROVED') {
    return {
      onClickPrimary: disablePrimaryButton(onApproveAndRequestReview({
        onRequestApproval: onRequestApproval,
        onApproveVersion: onApproveVersion
      }), setPrimaryButtonDisabled),
      onClickSecondary: onRequestChanges,
      primaryButtonText: primaryButtonDisabled ? 'Approval Requested' : 'Request Approval',
      secondaryButtonText: 'Submit Changes',
      secondaryButtonDisabled: status.isCustom,
      primaryButtonDisabled: primaryButtonDisabled
    };
  }

  return {
    onClickPrimary: onApproveVersion,
    onClickSecondary: onRequestChanges,
    primaryButtonText: 'Approve Version',
    secondaryButtonText: 'Submit Changes',
    secondaryButtonDisabled: secondaryButtonDisabled,
    primaryButtonDisabled: primaryButtonDisabled
  };
};

var getRequestChangesButton = function getRequestChangesButton(requestChanges, onRequestChangesForApproved) {
  return requestChanges ? /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    onClick: onRequestChangesForApproved,
    type: "PRIMARY"
  }, "Request Changes") : null;
};

var Footer = function Footer(props) {
  var status = props.status,
      hasUpdatePermission = props.hasUpdatePermission,
      requestChanges = props.requestChanges,
      onRequestChangesForApproved = props.onRequestChangesForApproved,
      hasInternalPermission = props.hasInternalPermission;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      primaryButtonDisabled = _useState2[0],
      setPrimaryButtonDisabled = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(_commonReact.NavigationFooter, deriveChildProps(props, primaryButtonDisabled, setPrimaryButtonDisabled), status.name === 'PENDING_REVIEW' && hasUpdatePermission || status.name === 'INTERNAL_REVIEW' && hasInternalPermission ? /*#__PURE__*/_react.default.createElement("div", {
    className: "video-review-footer__comment-text"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: "info",
    color: "regent",
    size: 15
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true,
    ellipsisOverflow: true
  }, "Add a comment by clicking anywhere on the video player")) : null, getRequestChangesButton(requestChanges, onRequestChangesForApproved));
};

var _default = (0, _react.memo)(Footer);

exports.default = _default;